import React from 'react';
import EnhancedOverallOrdersCard from './EnhancedOverallOrdersCard';

const AggregateMetricsVisualization = () => {
  return <EnhancedOverallOrdersCard />
};

export default AggregateMetricsVisualization;
